import type { TranslationKey } from "@/i18n";

export const locationStrings = {
  whatToDo: "location.gate.whatToDo",
  checking: "location.gate.checking",
  checkAgain: "location.gate.checkAgain",
  checkAgainA11y: "location.gate.checkAgainA11y",
  privacyTitle: "location.gate.privacyTitle",
  privacyBody: "location.gate.privacyBody",
  requiredFooter: "location.gate.requiredFooter",
  checkingEyebrow: "location.gate.states.checkingEyebrow",
  checkingTitle: "location.gate.states.checkingTitle",
  checkingBody: "location.gate.states.checkingBody",
  requiredEyebrow: "location.gate.states.requiredEyebrow",
  requiredTitle: "location.gate.states.requiredTitle",
  requiredWebBody: "location.gate.states.requiredWebBody",
  requiredNativeBody: "location.gate.states.requiredNativeBody",
  allowLocation: "location.gate.states.allowLocation",
  blockedEyebrow: "location.gate.states.blockedEyebrow",
  blockedWebTitle: "location.gate.states.blockedWebTitle",
  blockedWebBody: "location.gate.states.blockedWebBody",
  blockedNativeTitle: "location.gate.states.blockedNativeTitle",
  blockedNativeBody: "location.gate.states.blockedNativeBody",
  openSettings: "location.gate.states.openSettings",
  unavailableEyebrow: "location.gate.states.unavailableEyebrow",
  unavailableTitle: "location.gate.states.unavailableTitle",
  unavailableMacBody: "location.gate.states.unavailableMacBody",
  unavailableDeviceBody: "location.gate.states.unavailableDeviceBody",
  offEyebrow: "location.gate.states.offEyebrow",
  offTitle: "location.gate.states.offTitle",
  offBody: "location.gate.states.offBody",
  turnOnLocation: "location.gate.states.turnOnLocation",
  secureEyebrow: "location.gate.states.secureEyebrow",
  secureTitle: "location.gate.states.secureTitle",
  secureBody: "location.gate.states.secureBody",
  unsupportedEyebrow: "location.gate.states.unsupportedEyebrow",
  unsupportedTitle: "location.gate.states.unsupportedTitle",
  unsupportedBody: "location.gate.states.unsupportedBody",
  errorEyebrow: "location.gate.states.errorEyebrow",
  errorTitle: "location.gate.states.errorTitle",
  errorBody: "location.gate.states.errorBody",
  readyEyebrow: "location.gate.states.readyEyebrow",
  readyTitle: "location.gate.states.readyTitle",
  readyBody: "location.gate.states.readyBody",
  macOpenSettings: "location.gate.instructions.macOpenSettings",
  macOpenLocation: "location.gate.instructions.macOpenLocation",
  enableBrowser: "location.gate.instructions.enableBrowser",
  returnCheck: "location.gate.instructions.returnCheck",
  enableDevice: "location.gate.instructions.enableDevice",
  allowBrowser: "location.gate.instructions.allowBrowser",
  openHttps: "location.gate.instructions.openHttps",
  useLocalhost: "location.gate.instructions.useLocalhost",
  reloadCheck: "location.gate.instructions.reloadCheck",
  currentBrowser: "location.gate.instructions.currentBrowser",
  extensions: "location.gate.instructions.extensions",
  reloadRetry: "location.gate.instructions.reloadRetry",
  chromeControls: "location.gate.instructions.chromeControls",
  allowSite: "location.gate.instructions.allowSite",
  edgeSiteInfo: "location.gate.instructions.edgeSiteInfo",
  edgePermissions: "location.gate.instructions.edgePermissions",
  safariSettings: "location.gate.instructions.safariSettings",
  safariLocation: "location.gate.instructions.safariLocation",
  firefoxPermissions: "location.gate.instructions.firefoxPermissions",
  firefoxAllow: "location.gate.instructions.firefoxAllow",
  genericPermissions: "location.gate.instructions.genericPermissions",
  genericAllow: "location.gate.instructions.genericAllow",
  editorTitle: "location.editor.title",
  radiusMeters: "location.editor.radiusMeters",
  radiusKilometres: "location.editor.radiusKilometres",
  metersAway: "location.editor.metersAway",
  milesAway: "location.editor.milesAway",
  editorBody: "location.editor.body",
  editorCloseA11y: "location.editor.closeA11y",
  editorPlaceholder: "location.editor.placeholder",
  editorClearA11y: "location.editor.clearA11y",
  gpsUnavailable: "location.editor.gpsUnavailable",
  gpsRequired: "location.editor.gpsRequired",
  retryGpsA11y: "location.editor.retryGpsA11y",
  matchingPlaces: "location.editor.matchingPlaces",
  closestPlaces: "location.editor.closestPlaces",
  suggestionCount: "location.editor.suggestionCount",
  currentLocationA11y: "location.editor.currentLocationA11y",
  setLocationA11y: "location.editor.setLocationA11y",
  areaContextA11y: "location.editor.areaContextA11y",
  current: "location.editor.current",
  nearbyVenue: "location.editor.nearbyVenue",
  findingMatches: "location.editor.findingMatches",
  noMatch: "location.editor.noMatchTitle",
  minChars: "location.editor.minChars",
  tryName: "location.editor.tryName",
  noneInRadius: "location.editor.noneInRadius",
  tooFarTitle: "location.editor.tooFarTitle",
  tooFarBody: "location.editor.tooFarBody",
  tooFarA11y: "location.editor.tooFarA11y",
  updateFailed: "location.editor.updateFailedTitle",
  updateFailedBody: "location.editor.updateFailedBody",
} as const satisfies Record<string, TranslationKey>;

/** Foreground location gate, browser permission recovery, venue search, and GPS-bounded venue correction. Browser and platform product names remain unchanged. */
